import { supportEmail } from '../../../../../constants/utils';
import { businessErrorFactory, BusinessError } from '../../../../common/business-error';

import { BUSINESS_ERRORS } from './interfaces';

const CONTACT_WITH_SUPPORT = (
  <>
    If the problem still persists, contact with support at <b>{supportEmail}</b>
  </>
);

const GO_BACK = 'Please go back and repeat the process from the beginning.';
const TRY_AGAIN = 'Please try again.';

const OTP_VERIFICATION_UNEXPECTED_ERROR = (
  <span>
    Sorry we ran into an unexpected error and your profile could not be created. {TRY_AGAIN} {CONTACT_WITH_SUPPORT}
  </span>
);

const MISSING_OTP = (
  <span>
    Sorry we didn&#39;t apost received your OTP. {TRY_AGAIN} {CONTACT_WITH_SUPPORT}
  </span>
);

const ORDER_NOT_FOUND = (
  <span>
    Sorry we ran into an error while processing your settings and your profile could not be updated. {TRY_AGAIN}
    {CONTACT_WITH_SUPPORT}
  </span>
);

const OTP_COULD_NOT_BE_SEND = (
  <span>
    Sorry we ran into an unexpected error and OTP could not be send. {TRY_AGAIN}
    {CONTACT_WITH_SUPPORT}
  </span>
);

const INCORRECT_MSISDN = (
  <span>
    Your phone number could not be handled by the server. Specify another number.
    {CONTACT_WITH_SUPPORT}
  </span>
);

const INCORRECT_OTP = `Your OTP codes do not match. ${TRY_AGAIN}`;
const OTP_EXPIRED = `Your OTP codes expired. ${GO_BACK}`;
const EMAIL_ALREADY_EXISTS = 'Account corresponding to this E-mail already exists. Specify another E-mail.';
const MSISDN_ALREADY_USED = 'Phone number corresponding to this client already exists. Specify another number.';
const OTP_VERIFICATION_ERROR = `Your OTP codes do not match. ${TRY_AGAIN}`;
const PENDING_CLIENT_PROFILE_EXPIRED = `Pending account corresponding to this client expired. ${GO_BACK}`;

export const getProfileCreationBusinessError = (businessError: string): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.MSISDN_ALREADY_USED: {
      return businessErrorFactory({ message: MSISDN_ALREADY_USED, severity: 'warning' });
    }
    case BUSINESS_ERRORS.INCORRECT_MSISDN: {
      return businessErrorFactory({ message: INCORRECT_MSISDN, severity: 'warning' });
    }
    case BUSINESS_ERRORS.EMAIL_ALREADY_EXISTS: {
      return businessErrorFactory({ message: EMAIL_ALREADY_EXISTS, severity: 'warning' });
    }
    case BUSINESS_ERRORS.PENDING_CLIENT_PROFILE_EXPIRED: {
      return businessErrorFactory({ message: PENDING_CLIENT_PROFILE_EXPIRED, severity: 'warning' });
    }
    case BUSINESS_ERRORS.OTP_VERIFICATION_ERROR: {
      return businessErrorFactory({ message: OTP_VERIFICATION_ERROR, severity: 'warning' });
    }
    case BUSINESS_ERRORS.INCORRECT_OTP: {
      return businessErrorFactory({ message: INCORRECT_OTP, severity: 'warning' });
    }
    case BUSINESS_ERRORS.MISSING_OTP: {
      return businessErrorFactory({ message: MISSING_OTP, severity: 'error' });
    }
    case BUSINESS_ERRORS.ORDER_NOT_FOUND: {
      return businessErrorFactory({ message: ORDER_NOT_FOUND, severity: 'error' });
    }
    case BUSINESS_ERRORS.OTP_EXPIRED: {
      return businessErrorFactory({ message: OTP_EXPIRED, severity: 'warning' });
    }
    case BUSINESS_ERRORS.OTP_COULD_NOT_BE_SEND: {
      return businessErrorFactory({ message: OTP_COULD_NOT_BE_SEND, severity: 'error' });
    }
    default: {
      return businessErrorFactory({
        message: OTP_VERIFICATION_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};

const getOtpExhaustedLimitMsg = (duration: number) => (
  <span>
    Sorry, but you have reached the limit of OTP requests, please wait <b>{duration}</b> seconds and try again if
    necessary.
  </span>
);

const OTP_RESEND_UNEXPECTED_ERROR = (
  <span>
    Sorry we ran into an unexpected error and OTP could not be send. {TRY_AGAIN} {CONTACT_WITH_SUPPORT}
  </span>
);

const OTP_DELIVERY_FAILURE = (
  <span>
    Sorry we ran into an unexpected error and OTP could not be delivered. {TRY_AGAIN} {CONTACT_WITH_SUPPORT}
  </span>
);

const CLIENT_TO_CONFIRM_DOES_NOT_EXIST = OTP_RESEND_UNEXPECTED_ERROR;

export const getReSendOtpBusinessError = (businessError: string, apiParams?: Record<string, any>): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.OTP_RESEND_BLOCKED: {
      return businessErrorFactory({
        message: getOtpExhaustedLimitMsg(apiParams?.duration),
        severity: 'warning'
      });
    }
    case BUSINESS_ERRORS.OTP_DELIVERY_FAILURE: {
      return businessErrorFactory({
        message: OTP_DELIVERY_FAILURE,
        severity: 'error'
      });
    }
    case BUSINESS_ERRORS.CLIENT_TO_CONFIRM_DOES_NOT_EXIST: {
      return businessErrorFactory({
        message: CLIENT_TO_CONFIRM_DOES_NOT_EXIST,
        severity: 'error'
      });
    }
    default: {
      return businessErrorFactory({
        message: OTP_RESEND_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
